import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id B2B22BA8-6F5A-45F8-9A48-B6CC932DFD62
 * name format-letter-ends-with
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-letter-ends-with.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatLetterEndsWithIcon = createSvgIcon(<><path d="M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M20 14V18H2V20H22V14Z" /></>, 'FormatLetterEndsWithIcon');
export default FormatLetterEndsWithIcon